import { render, staticRenderFns } from "./consent-import-upload.vue?vue&type=template&id=52760b3e&scoped=true&"
import script from "./consent-import-upload.vue?vue&type=script&lang=js&"
export * from "./consent-import-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52760b3e",
  null
  
)

export default component.exports